import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import classes from "./ContentBody.module.css";

const ContentBody = () => {
  const nav = useNavigate();
  const innerComp = [1, 2, 3, 4];
  // const themes = [
  //   {
  //     name: "Basic",
  //     color: "#FFFFFF",
  //     borderRadius: "12px",
  //     linkBackgroundColor: "#ffffff",
  //   },
  //   {
  //     name: "Carbon",
  //     color: "#131212",
  //     borderRadius: "8px",
  //     linkBackgroundColor: "#212121",
  //   },
  //   {
  //     name: "Leaf",
  //     color: "#f5fdf4",
  //     borderRadius: "14px",
  //     linkBackgroundColor: "#A6EB99",
  //   },
  //   {
  //     name: "Rainy-Night",
  //     imageUrl: "https://cdn.bio.link/themes/backgrounds/rainy_night.jpg",
  //     borderRadius: "12px",
  //     linkBackgroundColor: "rgb(181 181 181 / 26%)",
  //   },
  //   {
  //     name: "Winter-live",
  //     imageUrl: "https://cdn.bio.link/themes/backgrounds/snowy.png",
  //     borderRadius: "12px",
  //     linkBackgroundColor: "#ffffff",
  //   },
  //   {
  //     name: "X-mus",
  //     imageUrl: "https://cdn.bio.link/themes/backgrounds/xmas-22.jpg",
  //     borderRadius: "14px",
  //     linkBackgroundColor: "#24673C",
  //   },
  // ];

  const [themes, setThemes] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await fetch(process.env.REACT_APP_API_URL +"themes-list");
      const result = await response.json();
      setThemes(result.data);
    })();
  }, []);
  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex align-items-center mb-4 flex-wrap">
            <h4 className="fs-20 font-w600  me-auto">Themes</h4>
            <div>
              <Link
                to={"/admin/add-theme"}
                className="btn btn-primary me-3 btn-sm"
              >
                <i className="fas fa-plus me-2" />
                Add New Theme
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    {themes.map((val) => {
                      return (
                        <React.Fragment key={val._id}>
                          <div className={`col-md-2 ${classes['card-hover']}`}>
                            <div
                              className={`py-5 px-4 ${classes["inner-layout"]}`}
                              onClick={() =>
                                nav("/admin/edit-theme/" + val._id)
                              }
                              style={
                                val.background === 2
                                  ? {
                                      backgroundImage:
                                        "url("+ process.env.REACT_APP_IMAGE_URL +"theme/" + val.themeImageMobile + ")",
                                    }
                                  : { background: val.color }
                              }
                            >
                              <div className="theme-lines">
                                {innerComp.map((e) => {
                                  return (
                                    <div
                                      key={e}
                                      className={classes["liner-style"]}
                                      style={{
                                        borderRadius: val.borderRadius + "px",
                                        backgroundColor:
                                          val.linkBackgroundColor,
                                      }}
                                    ></div>
                                  );
                                })}
                              </div>
                            </div>
                            <div className="theme-name mt-2 text-center">
                              <h4>{val.name}</h4>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContentBody;
